 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import OEBPSBCC from '@/components/OEBPS/bcc'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import OEBPSC02 from '@/components/OEBPS/c02'
 import OEBPSC03 from '@/components/OEBPS/c03'
 import OEBPSC04 from '@/components/OEBPS/c04'
 import OEBPSC05 from '@/components/OEBPS/c05'
 import OEBPSC06 from '@/components/OEBPS/c06'
 import OEBPSC07 from '@/components/OEBPS/c07'
 import OEBPSC08 from '@/components/OEBPS/c08'
 import OEBPSC09 from '@/components/OEBPS/c09'
 import OEBPSC10 from '@/components/OEBPS/c10'
 import OEBPSBPA from '@/components/OEBPS/bpa'
 import OEBPSCOP from '@/components/OEBPS/cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/OEBPS/bcc",
 			"name" : "OEBPS/bcc",
 			"component" : OEBPSBCC
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js